import { lazy } from 'react'

export const LicensesPageAsync = lazy(() => import('./LicensesPage'))
